import { SummaryCustomerAdvancePaymentModel } from '../../models/summary-customer-advance-payment.model';
import {
  CustomerAdvancePaymentActions,
  CustomerAdvancePaymentActionTypes,
  LoadCustomerAdvancePaymentsSuccess
} from '../actions/customer-advance-payment.actions';

export interface CustomerAdvancePaymentState {
  items: SummaryCustomerAdvancePaymentModel[];
  total: number;
  loading: boolean;
  error: any;
}

export const initialState: CustomerAdvancePaymentState = {
  items: [],
  total: 0,
  loading: false,
  error: null
};

export function CustomerAdvancePaymentReducer(
  state = initialState,
  action: CustomerAdvancePaymentActions
): CustomerAdvancePaymentState {
  switch (action.type) {
    case CustomerAdvancePaymentActionTypes.Load:
      return { ...state, loading: true, error: null };
    case CustomerAdvancePaymentActionTypes.LoadSuccess: {
      const { items, total } = (action as LoadCustomerAdvancePaymentsSuccess).payload;
      return { ...state, loading: false, items, total };
    }
    case CustomerAdvancePaymentActionTypes.LoadFailure:
      return { ...state, loading: false, error: (action as any).payload.error };
    default:
      return state;
  }
}
